import { IconQuestionMark } from '@tabler/icons-react';
import { Tooltip, Text } from '@mantine/core';
import { IconDeviceMobile, IconDeviceMobileStar, IconWorld } from '@tabler/icons-react';
import type { TestType } from '@prisma/client';
import { getTestTypeFriendlyName } from '~/common/test/test-type';
import { match } from 'ts-pattern';

export function TestTypeIcon({
  type,
  iconSize,
  className,
  showText,
  withinPortal,
}: {
  type?: TestType;
  iconSize?: number;
  className?: string;
  showText?: boolean;
  withinPortal?: boolean;
}) {
  const iconColor = className ?? 'text-stone-600 dark:text-stone-400';
  const size = iconSize ?? 20;
  const friendlyName = getTestTypeFriendlyName(type);
  const icon = match(type)
    .with('WEB', () => (
      <IconWorld
        size={size}
        className={iconColor}
      />
    ))
    .with('WEB_MOBILE', () => (
      <IconDeviceMobile
        size={size}
        className={iconColor}
      />
    ))
    .with('MOBILE_APP', () => (
      <IconDeviceMobileStar
        size={size}
        className={iconColor}
      />
    ))
    .with(undefined, () => (
      <IconQuestionMark
        size={size}
        className={iconColor}
      />
    ))
    .exhaustive();
  return (
    <Tooltip
      label={friendlyName}
      withinPortal={withinPortal}
    >
      {showText ?
        <div className="flex items-center gap-1">
          {icon}
          <Text
            size="xs"
            className="font-bold"
          >
            {friendlyName}
          </Text>
        </div>
      : icon}
    </Tooltip>
  );
}
